<template>
  <div class="carousel" v-if="slides.length > 0">
    <div
        class="slide"
        v-for="(slide, index) in slides"
        :key="slide.id || index"
        v-show="currentIndex === index"
    >
      <div class="content">
        <h1>{{ slide.titleA }}</h1>
        <h4>{{ slide.titleB }}</h4>
        <h4>{{ slide.description }}</h4>
        <button @click="goToLink(slide.linkUrl)">{{ slide.linkText }}</button>
      </div>
    </div>

    <div class="dots" v-if="dotCount > 1">
      <span
          v-for="index in dotCount"
          :key="isPreviewMode ? `static-dot-${index}` : `dot-${(slides[index-1] && slides[index-1].id) || (index-1)}`"
          :class="[
          'dot',
          {
            active: isPreviewMode ? index === 1 : currentIndex === (index - 1),
            'non-interactive': isPreviewMode
          }
        ]"
          @click="onDotClick(index - 1)"
      ></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Carousel",
  props: {
    banners: {
      type: Array,
      default: () => [],
    },
    isPreviewMode: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      currentIndex: 0,
      rotationMs: 5000,
      rotationTimer: null,
      isLoading: false,
      loadError: null,
    };
  },
  computed: {
    slides () {
      return (this.banners || [])
          .slice()
          .sort(
              (a, b) =>
                  (a.carouselBannerNumber ?? 0) -
                  (b.carouselBannerNumber ?? 0)
          )
          .map(b => {
            const titleA = b.titleA || (this.isPreviewMode ? "Header" : "");
            const titleB = b.titleB || (this.isPreviewMode ? "Title" : "");
            const description = (b.description ?? b.copy ?? "")
                || (this.isPreviewMode ? "Description" : "");
            const linkText = (b.linkText ?? b.linkTitle ?? "")
                || (this.isPreviewMode ? "Link Text" : "");
            const linkUrl = b.linkUrl || (this.isPreviewMode ? "" : "");

            return {
              id: b.id,
              partnerId: b.partnerId,
              titleA,
              titleB,
              description,
              linkUrl,
              linkText,
              carouselBannerNumber: b.carouselBannerNumber ?? 0,
            };
          });
    },
    dotCount () {
      return this.isPreviewMode ? 4 : this.slides.length;
    },
  },
  created () {
    if (!this.isPreviewMode) {
      this.startAutoRotate();
    } else {
      this.currentIndex = 0;
    }
  },
  beforeDestroy () {
    if (this.rotationTimer) clearInterval(this.rotationTimer);
  },
  methods: {
    startAutoRotate () {
      if (this.rotationTimer) clearInterval(this.rotationTimer);
      if (this.isPreviewMode) return;

      if (this.slides.length > 1) {
        this.rotationTimer = setInterval(() => {
          const len = this.slides.length;
          if (!Array.isArray(this.slides) || len === 0) return;
          this.currentIndex = (this.currentIndex + 1) % len;
        }, this.rotationMs);
      }
    },
    onDotClick (index) {
      if (this.isPreviewMode) return;
      this.goToSlide(index);
    },
    goToSlide (index) {
      if (index < 0 || index >= this.slides.length) return;
      this.currentIndex = index;
    },
    goToLink (link) {
      if (!link) return;

      if (this.isPreviewMode) {
        window.open(link, "_blank");
      } else {
        window.location.href = link;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.carousel {
  background-color: color(primary);
  color: white;
  height: 300px;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 40px;
}
.slide {
  text-align: start;
}
.content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
button {
  background-color: color(tertiary);
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 3px;
  cursor: pointer;
  max-width: 110px;
  margin-top: 10px;
}
.dots {
  position: absolute;
  bottom: 20px;
}
.dot {
  height: 15px;
  width: 15px;
  margin-right: 10px;
  background-color: color(tertiary-dark);
  border-radius: 50%;
  display: inline-block;
  cursor: pointer;
}
.dot.active {
  background-color: color(secondary);
}
.dot.non-interactive {
  cursor: default;
  pointer-events: none;
}
</style>